document.addEventListener('click', function(e) {

  /* Check whether click happened inside the Judge.me preview badge */
  var previewBadge = e.target.closest('.jdgm-preview-badge');

  if (!previewBadge) return;

  /* Reviews section */
  var reviewSection = document.getElementById('judgeme_product_reviews');

  if (!reviewSection) return;

  /* Detect Questions click */
  var questionClick = e.target.closest(
    '.jdgm-qa-badge, .jdgm-qa-badge__text, .jdgm-qa-badge__icon'
  );

  /* Detect Reviews / Stars click */
  var reviewClick = e.target.closest(
    '.jdgm-prev-badge__stars, .jdgm-prev-badge__text'
  );

  if (!questionClick && !reviewClick) return;

  e.preventDefault();
  e.stopPropagation();

  /* Scroll to Judge.me reviews */
  var headerOffset = 100;

  var targetPosition =
    reviewSection.getBoundingClientRect().top +
    window.pageYOffset -
    headerOffset;

  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });

  /* If Questions clicked, open Questions tab */
  if (questionClick) {

    setTimeout(function() {

      var questionTab = document.getElementById(
        'jdgm-tab_questions_answers'
      );

      if (questionTab) {
        questionTab.click();
      }

      /* Mobile Judge.me uses select dropdown */
      var mobileSelect = reviewSection.querySelector(
        '.jdgm-tab-dropdown__select'
      );

      if (mobileSelect) {
        mobileSelect.value = 'questions_answers';

        mobileSelect.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }

    }, 600);

  }

  /* If Reviews clicked, make sure Reviews tab is active */
  if (reviewClick) {

    setTimeout(function() {

      var reviewTab = document.getElementById(
        'jdgm-tab_product_reviews'
      );

      if (reviewTab) {
        reviewTab.click();
      }

      var mobileSelect = reviewSection.querySelector(
        '.jdgm-tab-dropdown__select'
      );

      if (mobileSelect) {
        mobileSelect.value = 'product_reviews';

        mobileSelect.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }

    }, 600);

  }

}, true);
